interface IconProps {
  color?: string;
  active?: boolean;
}

const SubmitIcon = (props: IconProps) => (
  <svg
    width='30'
    height='31'
    viewBox='0 0 30 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      className={props.active ? 'submit-icon__active' : 'submit-icon'}
      d='M5.75 25.1644C5.33333 25.331 4.9375 25.2944 4.5625 25.0544C4.1875 24.8144 4 24.4656 4 24.0081V18.3831L14 15.8831L4 13.3831V7.7581C4 7.29977 4.1875 6.95102 4.5625 6.71185C4.9375 6.47269 5.33333 6.43602 5.75 6.60185L25 14.7269C25.5208 14.956 25.7812 15.3414 25.7812 15.8831C25.7812 16.4248 25.5208 16.8102 25 17.0394L5.75 25.1644Z'
      fill={props.color}
    />
  </svg>
);

export default SubmitIcon;
